import { render, staticRenderFns } from "./AsStampHistoryPage.vue?vue&type=template&id=ce672a6e"
import script from "./AsStampHistoryPage.vue?vue&type=script&lang=js"
export * from "./AsStampHistoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports